import { render, staticRenderFns } from "./UserFeatureSingleSelect.vue?vue&type=template&id=1da612f2&"
import script from "./UserFeatureSingleSelect.vue?vue&type=script&lang=js&"
export * from "./UserFeatureSingleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports